<template>
  <el-tooltip :content="title[0].toUpperCase()+title.substring(1)" placement="top" :disabled="title==='icon'">
    <svg xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        :viewBox="viewBox"
        :aria-labelledby="title"
        role="presentation"
        :fill="fill"
    >
        <g>
        <slot />
        </g>
    </svg>
  </el-tooltip>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'icon'
    },
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    fill: {
      type: String,
      default: '#fff'
    },
    viewBox: {
        type: String,
        default: '0 0 26 26'
    }
  }
}
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
  margin-bottom: -2px;
  cursor: pointer;
}
</style>